import React from 'react';
import styled from 'styled-components';
import TableHeader from './TableHeader';
import TableBody from './TableBody';

const Table = ({
  columns,
  sortColumn,
  onSort,
  data,
  checkBox,
  setSelectedRows,
  selectedRows,
  tableRef,
  loading,
  handleSelectAll,
  handleRowClick,
  responsive = true,
  contentLoading = false,
  formListings= false,
   type = '',
}) => {
  const teamTable =
    columns[0]?.label === 'Employees' ||
    columns[1]?.label === 'Stages' ||
    columns[1]?.label === 'pipeline-templates';
  return (
    <TableShell className={`${!teamTable && responsive && 'table-responsive'}`}>
      <table className="table mb-0">
        <TableHeader
          columns={columns}
          data={data}
          handleSelectAll={handleSelectAll}
          checkBox={checkBox}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          sortColumn={sortColumn}
          tableRef={tableRef}
          onSort={onSort && onSort}
          formListings={formListings}
          type={type}
        />
        <TableBody
          columns={columns}
          checkBox={checkBox}
          handleRowClick={handleRowClick}
          data={data}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          tableRef={tableRef} // Use tableRef directly
          loading={loading}
          contentLoading={contentLoading}
          formListings={formListings}
        />
      </table>
    </TableShell>
  );
};

/* The shell is the table-body panel in both themes. The header sits flush
   with the top and sides; rows sit inside the box.
   Light box is white with a border and shadow. Dark box is the surface panel.
   Bootstrap's .table paints a solid --bs-table-bg and an inset accent
   shadow on every cell — clear both. */
const TableShell = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: visible;
  padding: 0 0 16px;
  background-color: ${({ theme }) =>
    theme?.dark ? theme.tableBodyBg || theme.surface : theme.white || '#fff'};
  border: none;
  border-radius: ${({ theme }) => theme.radiusCard};
  box-shadow: ${({ theme }) =>
    theme?.dark ? '0 0 2px 1px rgba(0, 0, 0, 0.45)' : '0 0 2px 1px #00000026'};

  &.table-responsive {
    overflow-x: auto;
    overflow-y: visible;
  }

  table.table {
    --bs-table-bg: transparent;
    --bs-table-accent-bg: transparent;
    --bs-table-hover-bg: transparent;
    --bs-table-striped-bg: transparent;
    --bs-table-border-color: transparent;
    background-color: transparent;
    border-collapse: separate;
    border-spacing: 0;
    margin-top: 0;
    margin-bottom: 0;

    > :not(caption) > * > * {
      border-bottom-width: 0;
      box-shadow: none;
    }
  }
`;

export default Table;
